<template>
    <v-tooltip bottom>
        <template #activator="{ on }">
            <v-btn small text icon dark v-on="on" to="vat" class="mr-3">
                {{ $t('vat.short') }}
            </v-btn>
        </template>
        {{ $t('vat.menu') }}
    </v-tooltip>
</template>

<script>
export default {
    name: 'kus-line-grid-topbar-vat'
}
</script>
